import Vue from 'vue';

Vue.component('staff-index', () =>
    import(/* webpackChunkName: 'staff-index' */ './staff-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/staff/index.js